<ng-container *ngIf="transactions$ | async as transactions">
  <ng-container *ngIf="transactions$ | async as transactions">
    <div *ngFor="let day of transactions | keyvalue : keepOrder">
      <h5 class="transaction-date">{{ day.key }}</h5>
      <div class="transaction-details d-flex flex-row align-items-center" *ngFor="let transaction of day.value">
        <div class="col-9 text-left">
          <div class="fw-bold text-black transaction-text font-size-14 m-0">
            {{ transaction.TransactionDescription }}
          </div>

          <div class="transaction-subtext fw-bold font-size-12 text-info">
            {{ transaction.TransactionDateUTC | UtcToLocaltimePipe : 'hh:mm a' | uppercase }}
          </div>
        </div>
        <div
          class="fw-bold transaction-text text-capitalize mb-0 d-flex justify-content-end font-size-12"
          [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
        >
          {{ transaction.Amount >= 0 ? '+' : ''
          }}{{ transaction.Amount | FortressCurrencyPipe : (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
        </div>
      </div>
    </div>
    <ng-container *ngIf="(!transactions || !hasTransactions) && transactionType === transactionTypes.loyalty">
      <div class="no-results-placeholder-div mt-4">
        <p class="mb-0 text-center font-size-12">{{ 'no.results.activity.description' | translate }}</p>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
